if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"menu_ui","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(2(229|270|992)|9(367|427|586)|1029|4427|5163|6545|7399|7556|8910)$/.test(chunkId)},
		rootOutputDir: "",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}